// extracted by mini-css-extract-plugin
export var legendIndicator = "_at-1";
export var legendRight = "_at-0";